import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GlobalModalChild, GlobalModalParent } from 'src/app/kanso-common/core/service';

@Component({
  selector: 'app-email-vendors',
  templateUrl: './email-vendors.component.html',
  styleUrls: ['./email-vendors.component.scss']
})
export class EmailVendorsComponent implements GlobalModalChild<any>, OnInit {
  // eslint-disable-next-line
  @Input() updateFunction: Function;
  globalModalParent: GlobalModalParent;
  form: FormGroup;
  customMessage: string;

  // eslint-disable-next-line
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      customMessage: [this.customMessage],
    });
  }

  closeDialog() {
    this.globalModalParent.closePopup();
  }

  sendEmail =  () =>{
    this.updateFunction(this.form.value);
    this.closeDialog();
  }
}
